<template>
  <page-wrapper :bgColor="'#0D75FF'">
    <transition
      mode="out-in"
      :name="'fade'"
      :duration="{ enter: 250, leave: 250 }"
    >
      <AboutPopup
        v-if="popup && apiData"
        :Data="apiData.options.about_popup"
        :Social="apiData.options.socials"
        :Method="togglePopup"
      />
    </transition>
    <transition
      mode="out-in"
      :name="'fade'"
      :duration="{ enter: 250, leave: 250 }"
    >
      <NewsletterPopup
        v-if="signup && apiData"
        :Data="apiData.options.newsletter_popup"
        :Method="toggleSignup"
      />
    </transition>
    <FcCircle :Method="togglePopup"/>
    <SignupWrapper v-if="apiData" :class="scrollState.y_offset >= 200 && 'show'">
      <LozengeButton @click.native="toggleSignup" :fillcolor="color">
        <span>{{apiData.options.newsletter_popup.popup_cta}}</span>
      </LozengeButton>
    </SignupWrapper>
    <HomeModules v-if="apiData" :Data="apiData" />
  </page-wrapper>
</template>

<script>
import { mapState } from 'vuex'
import styled from 'vue-styled-components'
import * as _ from '@/styles/mixins'
import { colors } from '@/styles/theme'
import randomArrItem from '@/scripts/randomArrItem'
import PageWrapper from '@/components/PageWrapper'
import HomeModules from './home/HomeModules'
import FcCircle from '@/components/FcCircle'
import AboutPopup from './AboutPopup'
import NewsletterPopup from './NewsletterPopup'
import { LozengeButton } from '@/styles/components'

// STYLES
const SignupWrapper = styled.div`
  display: flex;
  justify-content: centered;
  position: fixed;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 12000;
  width: 28rem;
  transform: translateY(20rem);
  opacity: 0;
  transition: opacity 250ms ease-in, transform 250ms ease-in;
  backface-visibility: hidden;
  perspective: 1000;
  will-change: opacity, transform;
  bottom: 5.5rem;
  &.show {
    transform: translateY(0);
    opacity: 1;
  }
  ${_.media.desktop`
    bottom: 2rem;
  `}
`

// VUE
export default {
  components: {
    PageWrapper,
    HomeModules,
    FcCircle,
    AboutPopup,
    NewsletterPopup,
    LozengeButton,
    SignupWrapper
  },
  data () {
    return {
      popup: false,
      signup: false,
      color: randomArrItem(colors.popup)
    }
  },
  methods: {
    togglePopup () {
      this.popup = !this.popup
    },
    toggleSignup () {
      this.signup = !this.signup
    }
  },
  computed: {
    ...mapState([
      'apiData',
      'scrollState'
    ])
  }
}
</script>
